import React, {useEffect, useState} from 'react';
import {requestGetDVTJCUVPipeLineList} from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import DVTJCUVPipelineTableList, {DVTJCUVPipelineListMode} from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import Button from "react-bootstrap/Button";
import {
    DVTJCUVSearchCddJobParentTabs,
    DVTJCUVSearchCddJobSetReceiverListTabs
} from "@pages/dvtjcuv/common/SearchCddJobTabs";
import {DEFAULT_PAGE, DEFAULT_PAGE_SIZE, ORDER_BY} from "@app/constants/Common";
import {requestCandidates} from "@app/services/CandidateService";
import {doExportExcel} from "@app/utils/CommonUtils";
import CandidateListTable, {CandidateListMode} from "@pages/candidate/list/CandidateListTable";

const DVTJCUVReceiversSentTabContent = (props) => {
    const [candidates, setCandidates] = useState([]);
    // const [selectedPipelines, setSelectedPipelines] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);

    const {cddId, parentTab} = props
    // alert('DVTJCUVReceiversSentTabContent:' + cddId)
    const fetchCandidateList = async (pTab, sTab, page, isExportExcel, candidateIds=[]) => {
        const params = {page: page > 0 ? page : DEFAULT_PAGE,
            size: DEFAULT_PAGE_SIZE, order_by: ORDER_BY.DESC_UPDATE_DATE,
            search_conditions: {
                search_cdd_job_mode: true,
                parent_tab: DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_SENT_TAB.id,
                unlimited: true
            }
        }

        if (cddId) {
            params.search_conditions.cdd_id = cddId;
        }

        if (isExportExcel) {
            params.is_export_excel = isExportExcel
        }

        const res = await requestCandidates(params);
        if (isExportExcel) {
            doExportExcel(res.content.candidates)
        }
        setCandidates(res.content.candidates);
        setTotalCount(res.content.totalCount)
    }

    useEffect(() => {
        console.log('parentTab', parentTab)
        fetchCandidateList()
    }, []);

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Receivers SENT</h3>
                    {/*<div className={'card-tools'}>*/}
                    {/*    <div className={'row'}>*/}
                    {/*        <Button className={'btn btn-default mr-3'} onClick={() => {}}>*/}
                    {/*            Source more Receivers*/}
                    {/*        </Button>*/}
                    {/*        <Button className={'btn btn-default mr-3'} onClick={() => {}}>*/}
                    {/*            Copy List Receivers*/}
                    {/*        </Button>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
                <div className='card-body'>
                    <CandidateListTable
                        showBtnSelect
                        hideBtnActions
                        candidates={candidates}
                        cddId={cddId}
                        // onReturnSelectedItems={onSelectCandidates}
                        // allCandidateIds={allCandidateIds}
                        mode={CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_RECEIVER_SENT}
                        totalCount={totalCount}
                        // onDelete={onDeleteReceivers}
                    />
                </div>
            </div>
        </>
    )
}
export default DVTJCUVReceiversSentTabContent;
